import { Box, Checkbox, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { ConstFilterElementsProps } from './dto';
import { FormattedMessage } from 'react-intl';

const ConstFilterElements: React.FC<ConstFilterElementsProps> = (props) => {
    return (
        <Stack display="grid" sx={{ py: 1 }}>
            <Box display="grid" sx={{ py: 1 }}>
                <InputLabel>
                    <FormattedMessage id="inside-fifa.generic-tables.filters.label" />
                </InputLabel>
                {props.languages.map((language) => (
                    <Box key={language} display="flex" alignItems="center" sx={{ py: 1 }}>
                        <TextField
                            aria-label={`Label for ${language}`}
                            label={language}
                            fullWidth
                            value={props.label && props.label[language] ? props.label[language] : undefined}
                            onChange={(e) => {
                                props.setLabel({
                                    ...props.label,
                                    [language]: e.target?.value,
                                });
                            }}
                        />
                    </Box>
                ))}
            </Box>
            <Box display="grid" sx={{ py: 1 }}>
                <InputLabel id="data-column-select-label">
                    <FormattedMessage id="inside-fifa.generic-tables.filters.data-column" />
                    {props.isDateFilter && (
                        <FormattedMessage id="inside-fifa.generic-tables.filters.data-column.date-type" />
                    )}
                </InputLabel>
                <Select
                    aria-labelledby="data-column-select-label"
                    fullWidth
                    value={props.selectedDataColumn}
                    onChange={(e) => props.setSelectedDataColumn(e.target.value)}
                >
                    {props.dataColumns?.map((column) => (
                        <MenuItem key={column.key} value={column.key} aria-label={column.title}>
                            {column.key}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
            {props.children}
            <Box sx={{ py: 2, display: 'flex', alignItems: 'center' }}>
                <Checkbox
                    aria-labelledby="data-column-show-filter"
                    checked={props.isShowOutsideChecked}
                    onChange={(e) => props.setShowOutsideChecked(e.target.checked)}
                />
                <InputLabel id="data-column-show-filter">
                    <FormattedMessage id="inside-fifa.generic-tables.filters.show-outside" />
                </InputLabel>
            </Box>
            {props.isShowHideOptionAllSelector ? 
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                        aria-labelledby="data-column-show-filter"
                        checked={props.isHideOptionAll}
                        onChange={(e) => props.setHideOptionAll(e.target.checked)}
                    />
                    <InputLabel id="data-column-show-filter">
                        <FormattedMessage id="inside-fifa.generic-tables.filters.hide-option-all" />
                    </InputLabel>
                </Box> : <></>
                }
        </Stack>
    );
};

export default ConstFilterElements;
